export const MOCK_LOCATION_DETAILS = {
  entity: {
    _schema: 'location',
    _id: 'loc-0000-0000-0000-000000000001',
    _org: 'test-org',
    _created_at: '2025-06-01T10:00:00.000Z',
    _updated_at: '2026-01-15T14:30:00.000Z',
    _title: 'Musterstraße 1, 80331 München',
    _acl: {
      view: ['org_test-org'],
      edit: ['org_test-org'],
      delete: ['org_test-org']
    },
    address: {
      street: 'Musterstraße',
      street_number: '1',
      postal_code: '80331',
      city: 'München',
      country: 'DE'
    },
    address_hash: 'abc123def456hash',
    building_area: 120,
    entity_relations: {
      $relation: [
        {
          entity_id: 'a1b2c3d4-0000-4000-8000-000000000001',
          _schema: 'asset'
        }
      ]
    }
  },
  relations: []
}
